import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-[600px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Premium%20streetwear%20fashion%20flat%20lay%20with%20sneakers%20hoodies%20and%20accessories%20on%20warm%20beige%20marble%20surface%20editorial%20product%20photography%20soft%20natural%20lighting%20minimalist%20aesthetic%20warm%20neutral%20tones&width=1600&height=900&seq=hero-bg&orientation=landscape"
          alt="CSSBuy Spreadsheet"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-6 text-center pt-20">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-white leading-tight mb-6 animate-fadeInUp">
          {t('heroH1')}
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed animate-fadeInUp" style={{ animationDelay: '0.15s' }}>
          {t('heroSubtitle')}
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center mb-6 animate-fadeInUp" style={{ animationDelay: '0.3s' }}>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 text-base font-medium bg-primary-500 text-white rounded-xl hover:bg-primary-600 transition-colors shadow-lg shadow-primary-500/25 whitespace-nowrap"
          >
            {t('heroCtaPrimary')}
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 text-base font-medium bg-white/10 backdrop-blur-sm text-white border border-white/30 rounded-xl hover:bg-white/20 transition-colors whitespace-nowrap"
          >
            {t('heroCtaSecondary')}
          </a>
        </div>
        <p className="text-sm text-white/60 animate-fadeIn" style={{ animationDelay: '0.45s' }}>
          {t('heroTrust')}
        </p>
      </div>
    </section>
  );
}